const platConfig = {
  app: 1020, //M站 APP
  qiyeweixin: 1033, //企业微信
  dingding: 1028, // 钉钉
  shengtai: 1035, // 生态
  fenxiao: 1005, // 分销
  feishu: 1040, //飞书
};

module.exports = {
  platConfig,
};
